module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "announcement"
  }, [(_vm.announcements[0] || !_vm.enableHistory) ? _c('div', [_c('transition', {
    attrs: {
      "name": "el-zoom-in-center",
      "mode": "out-in"
    }
  }, [(!_vm.showHistory) ? _c('el-card', {
    key: "single",
    staticClass: "box-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "zone"
    }
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.title['.value']))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', {
    attrs: {
      "id": "detail"
    }
  }, [_vm._v(_vm._s(_vm.detail['.value']))]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.enableHistory) ? _c('el-button', {
    staticClass: "show-history",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showHistory = true
      }
    }
  }, [_vm._v("所有公告")]) : _vm._e()], 1)])]) : _c('el-card', {
    key: "list"
  }, _vm._l((_vm.announcements), function(announcement, index) {
    return _c('el-button', {
      key: index,
      staticClass: "button",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.clickIndex = index;
          _vm.showHistory = false;
        }
      }
    }, [_vm._v("\n          " + _vm._s(announcement.title) + "\n        ")])
  }))], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2417ae7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Announcement.vue
// module id = 962
// module chunks = 1